import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const Discounts00Table: GenericTableSchemaInterface = {
  id: "discounts-00",
  name: "Discounts 00",
  description: "This table contains data regarding discounts.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Intent Start"
    },
    c04: {
      name: "General Start"
    },
    c05: {
      name: "Custom Start"
    },
    c06: {
      name: "Military Start"
    },
    c07: {
      name: "Student Start"
    },
    c08: {
      name: "Senior Start"
    },
    c09: {
      name: "Long Term Lease Start"
    },
    c10: {
      name: "Introductory Start"
    }
  }
};
